// extracted by mini-css-extract-plugin
export var container = "_sj-0";
export var table = "_sj-2";
export var tableWrapper = "_sj-1";